/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { PostfachActions } from './postfach.actions';

export const POSTFACH_FEATURE_KEY = 'PostfachState';

export interface PostfachPartialState {
  readonly [POSTFACH_FEATURE_KEY]: PostfachState;
}
export interface PostfachState {
  isDownloadPdfInProgress: boolean;
}

export const initialPostfachState: PostfachState = {
  isDownloadPdfInProgress: false,
};

const reducer: ActionReducer<PostfachState, Action> = createReducer(
  initialPostfachState,
  on(
    PostfachActions.startDownloadAsPdf,
    (state: PostfachState): PostfachState => ({
      ...state,
      isDownloadPdfInProgress: true,
    }),
  ),
  on(
    PostfachActions.downloadAsPdfSuccess,
    (state: PostfachState): PostfachState => ({
      ...state,
      isDownloadPdfInProgress: false,
    }),
  ),
  on(
    PostfachActions.downloadAsPdfFailed,
    (state: PostfachState): PostfachState => ({
      ...state,
      isDownloadPdfInProgress: false,
    }),
  ),
);

export function postfachReducer(state: PostfachState, action: Action): PostfachState {
  return reducer(state, action);
}
